export default "__VITE_ASSET__Djt6P6GU__"